import { Node, Edge } from './types';

export function logNodeFailure(debugTrace: string[], step: number, node: Node, reason: string) {
	if (debugTrace.length > 500) debugTrace.shift();
	debugTrace.push(
		`[step ${step}] Node ${node.id} (${node.x.toFixed(1)},${node.y.toFixed(1)}) failure: ${reason}`
	);
}

export function getNetworkSummary(nodes: Node[], edges: Edge[]): string {
	const avgEnergy = nodes.length > 0 ? (nodes.reduce((sum, n) => sum + n.energy, 0) / nodes.length).toFixed(2) : '0';
	const avgValue = nodes.length > 0 ? (nodes.reduce((sum, n) => sum + n.value, 0) / nodes.length).toFixed(2) : '0';
	return `Nodes: ${nodes.length}, Edges: ${edges.length}, AvgEnergy: ${avgEnergy}, AvgValue: ${avgValue}`;
}
